<template>
  <div class="select_dialog_embed">
    <div class="recharge_order_embed_msg">
      <div class="select_dialog_embed_box" :class="{'w650' : showType === 'log'}">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <!--日志-->
        <div v-if="showType === 'log'" class="select_dialog_embed_box_content recharge_order_embed_msg_log">
          <table class="table tb_border">
            <thead>
            <tr>
              <th>操作人</th>
              <th>操作时间</th>
              <th>操作内容</th>
            </tr>
            </thead>
            <tbody v-if="logList.length">
            <tr v-for="(item, index) in logList" :key="index">
              <td>{{item.CreaterName}}</td>
              <td>{{item.CreateTime | time}}</td>
              <td>{{item.Content}}</td>
            </tr>
            </tbody>
            <tbody v-if="!logList.length">
            <tr>
              <td colspan="3">{{logErr}}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <!--拒绝原因-->
        <div v-if="showType === 'refuseReason'" class="select_dialog_embed_box_content recharge_order_embed_msg_log">
          <p class="pt20 pr20 pb20 pl20">{{orderMsg.RejectReason}}</p>
        </div>

        <!--删除-->
        <div v-if="showType === 'del'" class="select_dialog_embed_box_content recharge_order_embed_msg_log">
          <p class="text_center mt20">是否确定删除所选工单？</p>
        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom pb20">
          <button v-if="showType !== 'log'" class="btn_normal" @click="submitBtn()">确定</button>
          <button class="btn_cancel" @click="cancelBtn()">关闭</button>
        </div>
      </div>
    </div>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>
  </div>
</template>

<script type="es6">
  import MsgDialog from '../../public-component/msg-dialog';

  export default {
    name: 'recharge-order-embed-msg',
    props: ['title', 'showType', 'orderMsg'],
    components: {MsgDialog},
    data() {
      return {
        logList: [], // 日志列表
        logErr: null, // 日志申请错误
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        time: 3, // 倒计时时间
        timer: null // 计时器
      }
    },
    methods: {
      // 删除充值工单
      deleteRechargeWorkOrder() {
        this.$axios.get(this.Global.deleteRechargeWorkOrder(this.orderMsg.Id)).then((res) => {
          if (!res.data.errorMsg.length) {
            this.cancelBtn(true);
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 查看日志（充值工单、申诉工单）
      getWorkOrderLogList() {
        const params = {
          WorkOrderId: this.orderMsg.OrderNo
        };
        this.$axios.post(this.Global.getWorkOrderLogList, params).then((res) => {
          if (!res.data.errorMsg.length) {
            this.logList = res.data.resData.DataList;
            if (!this.logList.length) {
              this.logErr = '暂时没有相关信息';
            }
          } else {
            this.logList = [];
            this.logErr = res.data.errorMsg;
          }
        });
      },

      // 提交按钮
      submitBtn() {
        if (this.showType === 'del') {
          this.deleteRechargeWorkOrder();
        } else {
          this.cancelBtn(false);
        }
      },

      // 取消按钮
      cancelBtn(type) {
        this.$emit('cancelbtn', {isShow: false, showType: this.showType, handleType: type});
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {
      console.log(this.showType);
      if (this.showType === 'log') {
        this.getWorkOrderLogList();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";
  .recharge_order_embed_msg {
    .select_dialog_embed_box {
      &.w650 {
        width: 650px;
      }

      .recharge_order_embed_msg_log {
        padding: 10px;

        table {
          td:nth-child(3) {
            text-align: left;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/money-management/recharge-order-embed-msg.vue